<template>
  <tax-document-preview
    v-if="isPrivateDocument"
    :key="item.id"
    :document-id="item.id"
    document-kind="invoice"
    :headers="documentHeaders"
    @close="handleClose"
  ></tax-document-preview>
  <v-card v-else>
    <v-row>
      <v-col cols="10">
      </v-col>
      <v-col cols="1">
        <v-icon
          medium
          color="error"
          class="ml-8 mt-2"
        >
        </v-icon>
      </v-col>
    </v-row>

    <div
      v-if="item.image && !isPrivateDocument"
      class="warning-logo"
    >
      <v-img
        width="400px"
        alt="logo"
        contain
        eager
        class="warning-logo"
        :src="editItem"
      ></v-img>
    </div>
    <div
      v-else-if="!isPrivateDocument"
      class="warning-logo"
    >
      <v-img
        width="300px"
        :src="require('@/assets/images/notImage.png')"
        alt="logo"
        contain
        eager
        class="warning-logo"
      ></v-img>
    </div>
    <v-card-text> </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="secondary"
        @click="handleClose"
      >
        İPTAL
      </v-btn>
      <v-btn
        class="primary"
        @click="handleSave"
      >
        ONAYLA
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiClose } from '@mdi/js'
import TaxDocumentPreview from '@/components/admin/TaxDocumentPreview.vue'
import { getAccessToken } from '@/utils/panelSession'

export default {
  components: { TaxDocumentPreview },
  props: {
    title: { type: String },
    fullName: { type: String },
    saveObj: { type: Object },
    item: { type: Object },
    save: undefined,
    close: undefined,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,

      image: {},
      images: {},
      toplamDeger: '',
      editItem: '',
      dialog: false,
      icons: { mdiClose },
    }
  },
  computed: {
    isPrivateDocument() { return this.item?.image?.localUrl?.startsWith('private-wallet-scan:') },
    documentHeaders() { return { Authorization: `Bearer ${getAccessToken()}` } },
  },
  setup() {
    return {
      PAYMENT_TYPE: {
        CASH_INSTALLMENT: 'Nakit',
        TRANSFER: 'Havale',
        FUTURES_PURCHASE_CREDIT: 'Mola Vadeli Peşinat',
        UFE_TUFE_INDEXED_CREDIT: 'Tüfe / Üfe Peşinat ',
      },
    }
  },

  watch: {
    item() {
      this.editItem = this.item.image ? this.item.image.localUrl : ''
    },
  },
  mounted() {
    this.editItem = this.item.image ? this.item.image.localUrl : ''
  },
  methods: {
    handleClose() {
      this.$props.close?.({})
    },
  },
}
</script>
<style lang="scss" scoped>
.warning-logo {
  transition: all 0.18s ease-in-out;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.actions {
  margin-bottom: 0px;
  margin-right: 170px;
}
</style>
